import { render, staticRenderFns } from "./TodoDeliveryOrderConsignment.vue?vue&type=template&id=17255ac6&scoped=true&"
import script from "./TodoDeliveryOrderConsignment.vue?vue&type=script&lang=js&"
export * from "./TodoDeliveryOrderConsignment.vue?vue&type=script&lang=js&"
import style0 from "./TodoDeliveryOrderConsignment.vue?vue&type=style&index=0&id=17255ac6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17255ac6",
  null
  
)

export default component.exports